import { useMemo } from "react";
import { useAppSelector } from "../../framework/customStore";
import {
    dailyAllowanceCategories,
    daybookingFillingHourCategories,
    fillingHourCategories,
    paidHourBookingCategories,
} from "../../models/workTime/hourBookingCategory";
import {
    makeSelectCalculatedWorkHoursAmountByDate,
    makeSelectCalculatedWorkHoursByDate,
    makeSelectNormalWorkHoursAmountByDate,
    makeSelectCalculatedWorkHoursAmountByDateGroupedBySalaryRowTypeId,
    makeSelectNormalWorkHoursByDate,
    makeSelectNormalWorkHoursByWorkShiftId,
    makeSelectCalculatedWorkHoursByWorkShiftId
} from "../../store/workHoursSlice";

export const useSelectCalculatedWorkHoursAmountBySalaryRowTypeId = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const selectWorkHoursAmountByDate = useMemo(
        makeSelectCalculatedWorkHoursAmountByDateGroupedBySalaryRowTypeId,
        []
    );

    return selectWorkHoursAmountByDate(state, employeeId, rangeStart, rangeEnd, null);
};

export const useSelectDailyAllowancesByDate = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string,
    normalOnly = false
) => {
    const state = useAppSelector((state) => state.workHours);
    const categories = useMemo(() => dailyAllowanceCategories(), []);
    const selectWorkHoursByDate = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursByDate
            : makeSelectCalculatedWorkHoursByDate,
        [normalOnly]
    );

    return selectWorkHoursByDate(
        state,
        employeeId,
        rangeStart,
        rangeEnd,
        categories
    );
};

export const useSelectDailyAllowancesByWorkShiftId = (
    employeeId: string,
    workShiftId: string,
    normalOnly = false
) => {
    const state = useAppSelector((state) => state.workHours);
    const categories = useMemo(() => dailyAllowanceCategories(), []);
    const selectWorkHoursByWorkShiftId = useMemo(
        normalOnly
            ? makeSelectNormalWorkHoursByWorkShiftId
            : makeSelectCalculatedWorkHoursByWorkShiftId,
        [normalOnly]
    );

    return selectWorkHoursByWorkShiftId(
        state,
        employeeId,
        workShiftId,
        categories
    );
};

export const useSelectCalculatedWorkHoursByWorkShiftId = (
    employeeId: string,
    workShiftId: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const selectWorkHoursByWorkShiftId = useMemo(
        makeSelectCalculatedWorkHoursByWorkShiftId,
        []
    );

    return selectWorkHoursByWorkShiftId(state, employeeId, workShiftId, null);
};

export const useSelectPaidWorkHoursAmountByDate = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => paidHourBookingCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        makeSelectNormalWorkHoursAmountByDate,
        []
    );
    return selectWorkHoursAmountByDate(
        state,
        employeeId,
        rangeStart,
        rangeEnd,
        categories
    );
};

export const useSelectCalculatedPaidWorkHoursAmountByDate = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string,
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => paidHourBookingCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        makeSelectCalculatedWorkHoursAmountByDate,
        []
    );
    return selectWorkHoursAmountByDate(
        state,
        employeeId,
        rangeStart,
        rangeEnd,
        categories
    );
};

export const useSelectFillingHoursAmountByDate = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => fillingHourCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        makeSelectNormalWorkHoursAmountByDate,
        []
    );
    return selectWorkHoursAmountByDate(
        state,
        employeeId,
        rangeStart,
        rangeEnd,
        categories
    );
};

export const useSelectDaybookingFillingHoursAmountByDate = (
    employeeId: string,
    rangeStart: string,
    rangeEnd: string,
    salaryRowTypeId: string
) => {
    const state = useAppSelector((state) => state.workHours);

    const categories = useMemo(() => daybookingFillingHourCategories(), []);
    const selectWorkHoursAmountByDate = useMemo(
        makeSelectCalculatedWorkHoursAmountByDate,
        []
    );
    return selectWorkHoursAmountByDate(
        state,
        employeeId,
        rangeStart,
        rangeEnd,
        categories,
        salaryRowTypeId
    );
};
